import { useCallback } from 'react';
import { updateChart, selectMetaIsLoaded } from '@/widgets/cohortChart';
import { cohortChartDataConfigValidator } from '@/features/chartsView';
import { ImportSharedPreset } from '@/features/SharePreset';
import { Analytics } from '@/shared/lib';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { useViewInitializationStateMachineContext } from '@/shared/ui';

export function ImportSharedViewDialog() {
  const dispatch = useAppDispatch();
  const isColumnsMetaLoaded = useAppSelector(selectMetaIsLoaded);
  const { onNavigatedViewApply, onNavigatedViewError } =
    useViewInitializationStateMachineContext();

  const handleApplyPreset = useCallback(
    (preset: unknown) => {
      const parsed = cohortChartDataConfigValidator.safeParse(preset);

      if (!parsed.success) {
        onNavigatedViewError();

        return;
      }

      onNavigatedViewApply();
      dispatch(updateChart(parsed.data));
      Analytics.sendFeatureUsage('share_view', 'apply');
    },
    [dispatch, onNavigatedViewApply, onNavigatedViewError],
  );
  const isPresetValid = useCallback((preset: unknown) => {
    const parseResult = cohortChartDataConfigValidator.safeParse(preset);

    return parseResult.success;
  }, []);

  if (!isColumnsMetaLoaded) {
    return null;
  }

  return (
    <ImportSharedPreset
      isPresetValid={isPresetValid}
      applyPreset={handleApplyPreset}
      onPresetError={onNavigatedViewError}
    />
  );
}
